import { Entity } from "../common-models/Entity";

export class FrontVersion extends Entity {
  number: number;
  numberName: string;
  description: string;
  createdAt: Date;
  mandatory: boolean;
  active: boolean;
}

export const FrontVersionResources = {
  currentNumber: 361,
  currentNumberName: '3.61',
  improvements: [
    'Ajuste na interface de vinculação de receitas para permitir a vinculação de receitas para pares com lentes planas.'
  ]
}